// The tavern palette, mirrored from .claude/rules/design-system.md
// in Phaser number format (0x...) so scenes can reference by token name.
export const PALETTE = {
  bg:          0x0d0d14,
  surface:     0x161625,
  raised:      0x1e1e32,
  border:      0x2a2a42,
  gold:        0xc9a96e,
  goldHover:   0xdbb978,
  goldMuted:   0x7a6a3e,
  cream:       0xe8e0d0,
  muted:       0x7a7568,
  danger:      0xb54545,
  success:     0x4a8a5a,

  // Derived tones for scene work
  wood:        0x3d2e1f,
  woodDark:    0x2a1f13,
  woodLight:   0x5a4428,
  stone:       0x3a3a50,
  stoneDark:   0x242436,
  firewarm:    0xe07a2c,
  fireBright:  0xffb864,
  ember:       0x7a2a12,
  candleFlame: 0xffda8a,
};
